var _path, _path2, _path3, _path4, _circle, _path5, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhoWeAre(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4487 40.3092C23.0433 39.2403 22.2324 37.1024 22.2324 37.1024L24.223 20.7364C26.1398 18.7828 30.9906 14.942 35.06 15.2074C39.1294 15.4728 43.8328 18.7091 45.6759 20.2941L48.6616 38.8719L47.224 40.7518M29.1873 24.1272V32.9611L25.0242 46.9736H45.4336L40.8643 33.1642V23.6195",
    stroke: "#4BB18C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4302 47.1527V66.3468H40.76V47.0195",
    stroke: "#4BB18C",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2949 47.0859V66.48",
    stroke: "#4BB18C",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99609 40.5437L1.99121 38.634L4.20223 20.9447C6.01136 19.0016 10.5543 15.0753 14.2529 14.9144C17.9516 14.7536 21.5564 16.4556 22.8965 17.3266M9.40164 23.6341L9.69888 32.1055L5.09164 47.2648L9.1735 47.2305M22.7775 47.1162L21.0458 47.1307M9.1735 47.2305V66.3144H15.2971M9.1735 47.2305L15.2971 47.1791M15.2971 66.3144V47.1791M15.2971 66.3144L21.0883 66.3227L21.0458 47.1307M15.2971 47.1791L21.0458 47.1307",
    stroke: "#4BB18C",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0713,
    cy: 6.69434,
    r: 5.00342,
    stroke: "#4BB18C",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.248 40.5437L68.2529 38.634L66.0419 20.9447C64.2328 19.0016 59.6899 15.0753 55.9912 14.9144C52.2926 14.7536 48.6877 16.4556 47.3476 17.3266M60.8425 23.6341L60.5453 32.1055L65.1525 47.2648L61.0706 47.2305M47.4666 47.1162L49.1983 47.1307M61.0706 47.2305V66.3144H54.9471M61.0706 47.2305L54.9471 47.1791M54.9471 66.3144V47.1791M54.9471 66.3144L49.1558 66.3227L49.1983 47.1307M54.9471 47.1791L49.1983 47.1307",
    stroke: "#4BB18C",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.00342,
    cy: 5.00342,
    r: 5.00342,
    transform: "matrix(-1 0 0 1 60.1763 1.69092)",
    stroke: "#4BB18C",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.01318,
    cy: 5.01318,
    r: 5.01318,
    transform: "matrix(-1 0 0 1 40.1523 1.69092)",
    stroke: "#4BB18C",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoWeAre);
export default __webpack_public_path__ + "static/media/who-we-are.7ab3228617d231ebe8b53bdf6b300720.svg";
export { ForwardRef as ReactComponent };